// extracted by mini-css-extract-plugin
export default {"container":"Compilations_container__nIWuR"};